
import VueScrollTo from 'vue-scrollto';
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import {
  ActionSimulatorAskForContact,
  State
} from '@/modules/pension/store/pension-landing';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

import { Heading, BaseText, Button } from '@warrenbrasil/nebraska-web';

const PensionModule = namespace('PensionLandingModule');

@Component({
  components: { Button, Heading, BaseText }
})
export default class PensionSectionHowTo extends Vue {
  @PensionModule.State('data')
  private state!: State;

  @PensionModule.Action('simulatorAskForContact')
  private simulatorAskForContact!: ActionSimulatorAskForContact;

  get NebraskaColors() {
    return NebraskaColors;
  }

  /**
   * Handle ask for a contact click.
   */
  handleButtonClick(): void {
    const { simulator } = this.state;
    if (!simulator.result) {
      VueScrollTo.scrollTo('#pension-card-simulator', 1000);
    } else {
      this.simulatorAskForContact();
    }
  }
}
